<template>
    <div class="forum_detail">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ documentTitle }}</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div><img src="../../assets/img/index/CXGheader.png" alt=""></div>
                    <div class="menuTab">
                        <div class="top">
                            <span v-for="(item, index) in menuTabList" :key="index" @click="jump(item)">{{ item.name }}</span>
                        </div>
                    </div>

                    <div class="footBottom">
                        <div class="left">
                            <div style="padding: 20px;" v-html="detail.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../../api/api'
import { decrypt } from '../../utils/decode'
import publicHeaders from '../../components/header.vue'
import foot from '../../components/foot.vue'
export default {
    name: 'forum_detail',
    components: {
        publicHeaders,
        foot
    },
    data() {
        return {
            documentTitle: '',
            menuTabList: [
                {
                    name: '首页',
                    title: '全国企业诚信建设示范基地',
                    url: '/developForum'
                },
                {
                    name: '通知文件',
                    title: '通知文件',
                    url: '/forum_detail'
                },
                {
                    name: '领导嘉宾',
                    title: '领导嘉宾',
                    url: '/forum_detail'
                },
                {
                    name: '活动议程',
                    title: '活动议程',
                    url: '/forum_detail'
                },
                {
                    name: '宣传报道',
                    title: '宣传报道',
                    url: '/forum_list'
                },
                {
                    name: '参会申请',
                    title: '参会申请',
                    url: '/forum_detail'
                },
                {
                    name: '往届回顾',
                    title: '往届回顾',
                    url: '/forum_list'
                },
            ],
            detail: {},
            tree: [],
            page: 1,
            loading: false,
            empty: false,
        }
    },
    created() {
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle
        if (this.$route.query.id != undefined) {
            this.getInfo(this.$route.query.id)
        } else {
            this.getTree()
        }
        
    },
    mounted() {
    },
    methods: {
        // 获取分类
        getTree() {
            let _this = this
            this.tree = []
            let params = {}
            api.getTree().then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.tree = data.data
                    
                    _this.getList()
                } else {
                    
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取列表
        getList() {
            let _this = this
            let params = {
                cateId: '',
                title: '',
                page: _this.page,
                size: 10,
            }
            _this.tree.forEach(element => {
                if (element.name == _this.documentTitle) {
                    params.cateId = element.id
                }
            });
            api.getList(params).then(res => {
                let { data } = res
                // console.log(data);
                if (data.status == 200) {
                    if (data.data.total != 0) {
                        this.getInfo(data.data.data[0].id)
                        _this.empty = true
                    } else {
                        _this.empty = false
                    }
                } else {
                    _this.empty = true
                }
            })
            .catch(error => {
                _this.empty = true
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 获取详情
        getInfo(id) {
            let _this = this
            _this.loading = true
            _this.detail = {}
            let params = {
                id: id,
            }
            api.getInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.detail = data.data
                    _this.loading = false
                } else {
                    _this.loading = false
                }
            })
            .catch(error => {
                _this.loading = false
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        jump(item) {
            if (item.url != '') {
                this.$router.push({
                    path: item.url,
                    query: {
                        documentTitle: item.title
                    }
                })
                // let routeUrl = this.$router.resolve({
                //   path: item.url
                // });
                // // console.log(routeUrl);
                // window.open(routeUrl.href+ '?documentTitle=' + item.title, '_blank');
            }
        },
    }
}
</script>

<style lang="less" scoped>
.forum_detail {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 80%;
        padding: 15px 50px;
        margin: 0 auto;
        @media only screen and (min-width: 769px) {
            min-width: 1152px;
        }
        .left {
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 600px;
                margin-top: 10px;
                .menuTab {
                    margin-top: 15px;
                    color: #134AA6;
                    padding: 0 235px;
                    background-color: #E8F1FF;
                    .top {
                        padding: 10px 0;
                        display: flex;
                        span {
                            flex: 1;
                            cursor: pointer;
                            text-align: center;
                        }
                        span:nth-of-type(n+2) {
                            border-left: 1px solid #98C8F8;
                        }
                    }
                }
                .publicity {
                    margin-top: 15px;
                    position: relative;
                    .text {
                        position: absolute;
                        bottom: -78px;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 1266px;
                        height: 154px;
                        border: 1px solid #1A68E8;
                        background-color: #fff;
                        padding: 20px;
                        color: #666;
                        line-height: 26px;
                    }
                }
                .footBottom {
                    min-height: 200px;
                    margin-top: 15px;
                    display: flex;
                    justify-content: space-between;
                    .left {
                        width: 77%;
                        border: 1px solid #5797FF;
                    }
                    .right {
                        width: 23%;
                    }
                }
            }
        }
    }
}
</style>
